import React from "react";
import { BoxLoading } from "react-loadingg";

const Loading = () => {
  return <BoxLoading />;
};

export default Loading;
